<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>
  <p class="pm-dialog-query">{{data.body | translate:data.bodyTranslationArguments}}</p>
  @if (error !== null) {
    <p class="pm-dialog-error">{{error}}</p>
  }
</div>
<div mat-dialog-actions>
  <button mat-button type="submit" [disabled]="working" (click)="closeDialog('continue')"><span
    class="inliner">@if (working) {
    <mat-spinner diameter="16"></mat-spinner>
  }{{(data.continueButton || 'button.save') | translate}}</span></button>
  @if (!data.hideSaveButton) {
    <button mat-button (click)="closeDialog('drop')">{{(data.dropButton || 'button.dont-save') | translate}}</button>
  }
  <button mat-button (click)="closeDialog('cancel')">{{(data.cancelButton || 'button.cancel') | translate}}</button>
</div>
